import React from 'react';

const PartA2 = ({ data }) => {
    // Use empty object as fallback for data to prevent errors
    const safeData = data || {};
    const learningsSchool = safeData.learnings_school || [];
    const learningsOutside = safeData.learnings_outside_school || [];

    return (
        <div className="report-page relative font-[poppins] bg-white" style={{
            width: '210mm',
            height: '297mm',
            padding: '15mm 20mm',
            margin: '0 auto',
            fontSize: '10pt',
            lineHeight: '1.6', // Increased line-height for more vertical space
            color: '#333333',
            boxSizing: 'border-box',
            overflow: 'hidden',
            position: 'relative',
            breakInside: 'avoid',
            pageBreakInside: 'avoid',
            '@media print': {
                margin: 0,
                padding: '15mm 20mm',
                boxShadow: 'none',
                width: '210mm',
                height: '297mm'
            }
        }}>
            {/* Orange corner triangles */}
            <div className="absolute top-0 right-0 w-0 h-0"
                style={{
                    borderTop: '80px solid #f1905b',
                    borderLeft: '80px solid transparent'
                }}>
            </div>
            <div className="absolute bottom-0 left-0 w-0 h-0"
                style={{
                    borderBottom: '80px solid #F97316',
                    borderRight: '80px solid transparent'
                }}>
            </div>

            <div className="relative z-10">
                {/* Header */}
                <h2 className="text-center font-bold text-lg text-orange-600 mb-2 mt-2">PART A (2)</h2>

                {/* All About Me Section */}
                <div className="mb-3 relative">
                    {/* Header */}
                    <div className="bg-[#ffc000] text-center py-1 px-4 font-bold text-base text-black relative z-0">
                        All About Me!
                    </div>

                    {/* Content Box */}
                    <div className="bg-yellow-50 p-2 relative min-h-[180px] z-0">

                        {/* UPDATED STARBURST NAME BOX */}
                        {/* Made larger (240px), removed rotation, adjusted position to overlap header */}
                        <div
                            className="absolute -right-2 -top-22 z-20"
                            style={{ width: '240px', height: '240px' }}
                        >
                            <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 130 130"
                                className="absolute inset-0 drop-shadow-sm"
                                style={{ overflow: 'visible' }}
                            >
                                {/* Scaled the path slightly to fill the box better */}
                                <polygon
                                    points="65,5 78,22 98,15 92,35 112,35 100,50 120,62 100,74 112,90 92,90 98,110 78,102 65,120 52,102 32,110 38,90 18,90 30,74 10,62 30,50 18,35 38,35 32,15 52,22"
                                    fill="white"
                                    stroke="#e36c09"
                                    strokeWidth="1"
                                />
                            </svg>
                            <div className="absolute inset-0 flex items-center justify-center p-8">
                                {/* Removed rotation from text to match reference */}
                                <span className="font-extrabold text-2xl text-black text-center leading-tight w-full">
                                    {safeData.name || safeData.student_name || 'Name'}
                                </span>
                            </div>
                        </div>
                        {/* END UPDATED STARBURST */}

                        {/* Increased padding-right (pr-64) so text doesn't go behind the big star */}
                        <div className="space-y-2 pr-64 relative z-10">
                            <div className="flex items-end">
                                <span className="font-normal">I live with my</span>
                                <span
                                    className="border-b border-gray-500 flex-1 mx-2 pb-0.5 text-blue-600 font-semibold">{safeData.family || ''}</span>
                                <span className="font-normal">. We stay at</span>
                                <span
                                    className="border-b border-gray-500 flex-1 ml-2 pb-0.5 text-blue-600 font-semibold">{safeData.live_in || ''}</span>
                                <span>.</span>
                            </div>
                            <div className="flex items-end">
                                <span className="font-normal">I spend my free time doing</span>
                                <span
                                    className="border-b border-gray-500 flex-1 ml-2 pb-0.5 text-blue-600 font-semibold">{safeData.favourite_sports || ''}</span>
                                <span>.</span>
                            </div>
                            <div className="flex items-end">
                                <span className="font-normal">I</span>
                                <span
                                    className="border-b border-gray-500 flex-1 mx-2 pb-0.5 text-blue-600 font-semibold">{safeData.favourite_subjects || ''}</span>
                                <span className="font-normal">very well.</span>
                            </div>
                            <div className="flex items-end">
                                <span className="font-normal">I am responsible</span>
                                <span
                                    className="border-b border-gray-500 w-32 mx-2 pb-0.5 text-blue-600 font-semibold">{safeData.friends_are || ''}</span>
                                <span className="font-normal text-xs text-gray-600">(sometimes, most times, all the time)</span>
                            </div>
                            <div className="flex items-end">
                                <span className="font-normal">I could do better specially when it comes to</span>
                                <span
                                    className="border-b border-gray-500 flex-1 ml-2 pb-0.5 text-blue-600 font-semibold">{safeData.favourite_animals || ''}</span>
                                <span>.</span>
                            </div>
                            <div className="flex items-end">
                                <span className="font-normal">I care about others. I show it by</span>
                                <span
                                    className="border-b border-gray-500 flex-1 ml-2 pb-0.5 text-blue-600 font-semibold">{safeData.favourite_colours || ''}</span>
                                <span>.</span>
                            </div>
                            <div className="flex items-end">
                                <span className="font-normal">I feel proud of myself when</span>
                                <span
                                    className="border-b border-gray-500 flex-1 ml-2 pb-0.5 text-blue-600 font-semibold">{safeData.favourite_foods || ''}</span>
                                <span>.</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* My Goal Setting Section */}
                <div className="mb-3">
                    <div className="bg-orange-500 py-1 px-4 font-bold text-base text-white text-center">
                        My Goal Setting
                    </div>
                    <div className="bg-orange-100 p-2">
                        <div className="grid grid-cols-2 gap-x-5">
                            {/* Left Column - Academic Goal */}
                            <div className="flex flex-col justify-between">
                                <div
                                    className="bg-blue-200 border-2 border-blue-400 rounded-lg p-2 text-center font-bold min-h-[100px] flex items-center justify-center">
                                    <div>
                                        <div className="text-base">My Academic Goal</div>
                                        <div className="mt-1 text-sm font-semibold text-gray-800">
                                            {safeData.academic_goal || ''}
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <div className="mb-2 text-sm">
                                        <span className="font-normal">This goal is important to me because</span>
                                        <span
                                            className="border-b border-gray-500 block w-full min-h-[1.6em] text-blue-600 font-semibold">{safeData.academic_goal_importance || ''}</span>
                                    </div>
                                    <div className="mb-1 text-sm">
                                        <span className="font-normal">I will reach this goal by:</span>
                                    </div>
                                    <div className="mb-2 pl-3 text-sm">
                                        <div className="flex items-center">
                                            <span className="font-normal mr-2">Step 1</span>
                                            <span
                                                className="flex-1 border-b border-gray-500 min-h-[1.6em] text-blue-600 font-semibold flex items-center">
                                                {safeData.academic_goal_step1 || ''}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="pl-3 text-sm">
                                        <div className="flex items-center">
                                            <span className="font-normal mr-2">Step 2</span>
                                            <span
                                                className="flex-1 border-b border-gray-500 min-h-[1.6em] text-blue-600 font-semibold flex items-center">
                                                {safeData.academic_goal_step2 || ''}
                                            </span>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {/* Right Column - Personal Goal */}
                            <div className="flex flex-col justify-between">
                                <div className="mt-0">
                                    <div className="mb-2 text-sm">
                                        <span className="font-normal">This goal is important to me because</span>
                                        <span
                                            className="border-b border-gray-500 block w-full min-h-[1.6em] text-blue-600 font-semibold">{safeData.personal_goal_importance || ''}</span>
                                    </div>
                                    <div className="mb-1 text-sm">
                                        <span className="font-normal">I will reach this goal by:</span>
                                    </div>
                                    <div className="mb-2 pl-3 text-sm">
                                        <div className="flex items-center">
                                            <span className="font-normal mr-2">Step 1</span>
                                            <span
                                                className="flex-1 border-b border-gray-500 min-h-[1.6em] text-blue-600 font-semibold flex items-center">
                                                {safeData.personal_goal_step1 || ''}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="pl-3 text-sm">
                                        <div className="flex items-center">
                                            <span className="font-normal mr-2">Step 2</span>
                                            <span
                                                className="flex-1 border-b border-gray-500 min-h-[1.6em] text-blue-600 font-semibold flex items-center">
                                                {safeData.personal_goal_step2 || ''}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="bg-pink-200 border-2 border-pink-400 rounded-lg p-2 text-center font-bold min-h-[100px] flex items-center justify-center mt-3">
                                    <div>
                                        <div className="text-base">My Personal Goal</div>
                                        <div className="mt-1 text-sm font-semibold text-gray-800">
                                            {safeData.personal_goal || ''}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* My Learnings Section */}
                <div className="mb-3">
                    <div className="bg-sky-600 py-1 px-4 font-bold text-base text-white text-center">
                        My Learnings
                    </div>
                    <div className="bg-sky-100 p-2">
                        <div className="grid grid-cols-2 gap-x-6">
                            <div>
                                <h4 className="font-semibold mb-2 text-sm">Three new things I learnt at school:</h4>
                                <ol className="list-decimal space-y-2 pl-5 text-sm">
                                    <li className="text-blue-600 font-semibold min-h-[1.5em]">{learningsSchool[0] || ''}</li>
                                    <li className="text-blue-600 font-semibold min-h-[1.5em]">{learningsSchool[1] || ''}</li>
                                    <li className="text-blue-600 font-semibold min-h-[1.5em]">{learningsSchool[2] || ''}</li>
                                </ol>
                            </div>
                            <div>
                                <h4 className="font-semibold mb-2 text-sm">Three new things I learnt outside
                                    school:</h4>
                                <ol className="list-decimal space-y-2 pl-5 text-sm">
                                    <li className="text-blue-600 font-semibold min-h-[1.5em]">{learningsOutside[0] || ''}</li>
                                    <li className="text-blue-600 font-semibold min-h-[1.5em]">{learningsOutside[1] || ''}</li>
                                    <li className="text-blue-600 font-semibold min-h-[1.5em]">{learningsOutside[2] || ''}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <table className="w-full border-collapse mb-2 font-['Times New Roman',Times,serif]">
                    <thead>
                        <tr>
                            <th
                                colSpan={1}
                                className="bg-[#17ae4b] py-2 px-4 font-bold text-base text-white text-center"
                            >
                                For My Teacher
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="bg-[#e1f7df] px-3 pt-2 pb-0 text-base">
                                I would like my teacher to help me with
                            </td>
                        </tr>
                        <tr>
                            <td className="bg-[#e1f7df] px-3 pt-0 pb-2 text-base align-top">
                                <div className="border-b border-[#17ae4b] w-full" style={{ minHeight: '1.5em' }} />
                            </td>
                        </tr>
                        <tr>
                            <td className="bg-[#e1f7df] px-3 pt-2 pb-0 text-base">
                                I would like my teacher to know
                            </td>
                        </tr>
                        <tr>
                            <td className="bg-[#e1f7df] px-3 pt-0 pb-2 text-base align-top">
                                <div className="border-b border-[#17ae4b] w-3/4" style={{ minHeight: '1.5em' }} />
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    );
};

export default PartA2;